import API_BASE_URL from '../Config';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export const getBarriosPorCiudad = async (ciudadId) => {
    const response = await fetch(`${API_BASE_URL}/barrios/por-ciudad/${ciudadId}`, {
        headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Error al listar barrios');
    return response.json();
};

export const getBarriosPaginados = async (page = 0, size = 10, search = '') => {
    const response = await fetch(`${API_BASE_URL}/barrios/page?page=${page}&size=${size}&search=${search}`, {
        headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Error al cargar barrios paginados');
    return response.json();
};

export const getBarrioById = async (id) => {
    const response = await fetch(`${API_BASE_URL}/barrios/${id}`, {
        headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Barrio no encontrado');
    return response.json();
};

export const createBarrio = async (data) => {
    const response = await fetch(`${API_BASE_URL}/barrios`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear barrio');
    return response.json();
};

export const updateBarrio = async (id, data) => {
    const response = await fetch(`${API_BASE_URL}/barrios/${id}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar barrio');
    return response.json();
};

export const deleteBarrio = async (id) => {
    const response = await fetch(`${API_BASE_URL}/barrios/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
    });
    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Error al eliminar barrio');
    }
};
